import { useMemo, useState } from "react";

function useTestimonial(list) {
	const [activeIndex, setActiveIndex] = useState(0);
	const active = useMemo(() => list[activeIndex], [activeIndex, list]);
	return [active, activeIndex, setActiveIndex];
}

export default useTestimonial;
